import { Observable } from "rxjs";

import { get, post } from "@utils/axios";
import sessionService from "./session.service";

class ConfigService {
  // private base: string = `${process.env.REACT_APP_API_BASE_URI}/config`;

  getAppConfig(): Observable<any> {
    return get(`${sessionService.getClient()?.appServiceUrl}/config/get`);
  }

  updateAppConfig(config: any): Observable<any> {
    return post(`${sessionService.getClient()?.appServiceUrl}/config/update`, config);
  }
}

export default new ConfigService();
